import React, {useEffect, useState, useMemo, useCallback, useRef} from 'react'
import {useIntl} from 'react-intl'
import InpatientPage from './InpatientPage'
import {FaComment} from 'react-icons/fa'
import {HiOutlineDocumentDownload} from 'react-icons/hi'
import axios from 'axios'
import './style.css'
import {useLocation} from 'react-router-dom'
import ChatModal from './tab-components/ChatModal'
import DocumentModal from './tab-components/DocumentModal'
import {toast} from 'react-toastify'
import {useAuth} from '../../modules/auth'
import {useNavigate} from 'react-router-dom'
import {createPusherClient} from '../../../_metronic/helpers/pusherClient'
import {CreateAppModal} from '../../../_metronic/partials/modals/request-fgl-stepper/CreateAppModal'
import {saveAs} from 'file-saver'
import {debounce} from 'lodash'
import {setGlobalAttention} from '../../../_metronic/layout/components/header/Header'
import {useClaimAttention} from '../../../hooks/useClaimAttention'
import {usePageData} from '../../../_metronic/layout/core/PageData'
import {Modal} from 'react-bootstrap'
import {IoIosClose} from 'react-icons/io'
import {LuDownload} from 'react-icons/lu'
import {useQueryClient} from 'react-query'
import SupersedingTrackingModal from './tab-components/SupersedingTrackingModal'
import {useSupersedingCycles, useUploadSupersedingDocuments} from '../../../hooks/useSuperseding'

interface DocumentStatus {
  status: string
  id: number
  name: string
  isArchive: boolean
}

interface DiagnosisData {
  mainDiagnosis?: string
  supportingDiagnosis?: string
  supportingDiagnosis3?: string
  supportingDiagnosis4?: string
  icd1?: string
  icd2?: string
  icd3?: string
  icd4?: string
  doctor?: string
  polyName?: string
  remark?: string
  deposit?: string
  rencanaTindakan?: string
  losEstimation?: string
  originalIcdCodes?: {
    icd1?: string
    icd2?: string
    icd3?: string
    icd4?: string
  }
  indate?: string
}
const SUPERSEDING_CATEGORIES: {value: string; i18nKey: string}[] = [
  {value: 'Request for Approval – Procedure', i18nKey: 'CLAIM.INPATIENT.SUPERSEDING_CATEGORY_SPT_PROCEDURE'},
  {value: 'Request for Approval – Medication', i18nKey: 'CLAIM.INPATIENT.SUPERSEDING_CATEGORY_SPT_MEDICATION'},
  {value: 'Request for Approval – Lab/Radiology', i18nKey: 'CLAIM.INPATIENT.SUPERSEDING_CATEGORY_SPT_LAB_RAD'},
  {value: 'Administrative Data Change', i18nKey: 'CLAIM.INPATIENT.SUPERSEDING_CATEGORY_DATA_ADMIN'},
  {value: 'Billing Data Change', i18nKey: 'CLAIM.INPATIENT.SUPERSEDING_CATEGORY_DATA_BILLING'},
  // Legacy categories retained as selectable options (IDH-1374).
  {value: 'Medication & Treatment', i18nKey: 'CLAIM.INPATIENT.SUPERSEDING_CATEGORY_MEDICATION'},
  {value: 'Change Data', i18nKey: 'CLAIM.INPATIENT.SUPERSEDING_CATEGORY_CHANGE_DATA'},
  {value: 'Others', i18nKey: 'CLAIM.INPATIENT.SUPERSEDING_CATEGORY_OTHERS'},
]

const InpatientPageWrapper: React.FC = () => {
  const user = useAuth()
  const {auth} = useAuth()
  const location = useLocation()
  const navigate = useNavigate()
  const {formatMessage: f} = useIntl()
  const queryClient = useQueryClient()
  const claimDetails = location.state as {claimDetails: any}
  const [isLoading, setIsLoading] = useState(false)
  const [showCancelModal, setShowCancelModal] = useState(false)
  const [remark, setRemark] = useState('')
  const [showRemarkError, setShowRemarkError] = useState(false)
  const [isConfirmCancel, setIsConfirmCancel] = useState(false)
  const [activeKey, setActiveKey] = useState<string>('diagnosis')
  const [validationData, setValidationData] = useState<any>(null)
  const [isDataValid, setIsDataValid] = useState<boolean>(false)
  const [isEditingDiagnosis, setIsEditingDiagnosis] = useState<boolean>(false)
  const [isChatOpen, setIsChatOpen] = useState<boolean>(false)
  const [chatMessage, setChatMessage] = useState<string>('')
  const [currentView, setCurrentView] = useState<
    'inpatient' | 'calendar' | 'dailyMonitoringDetail' | 'discharged'
  >('inpatient')
  const [status, setStatus] = useState<string>(claimDetails.claimDetails?.claim?.status)
  const [showFGLModal, setShowFGLModal] = useState<boolean>(false)
  const [formattedDate, setFormattedDate] = useState<string>(new Date().toISOString().split('T')[0])
  const [incomingsinglefile, setIncomingsinglefile] = useState<any>(null)
  const [documentsUploaded, setDocumentsUploaded] = useState<boolean>(false)
  const [documentsChecked, setDocumentsChecked] = useState<boolean>(false)
  const [diagnosisFieldsFilled, setDiagnosisFieldsFilled] = useState<boolean>(false)
  const [documentsUploadedNew, setDocumentsUploadedNew] = useState<boolean>(false)
  const [notificationCount, setNotificationCount] = useState(0)
  const [hasNewNotification, setHasNewNotification] = useState(false)
  const [isFromDailyMonitoring, setIsFromDailyMonitoring] = useState<boolean>(false)
  const [documentRealtime, setDocumentRealtime] = useState<any>(null)
  const [view, setView] = useState<string>('inpatient')
  const [loading, setLoading] = useState<boolean>(false)
  const jsonString = claimDetails?.claimDetails?.claim?.detailBenefit
  const parsedJson = jsonString ? JSON.parse(jsonString) : {}
  const jsonString2 = claimDetails?.claimDetails?.claim?.claimData
  const parsedJson2 = jsonString2 ? JSON.parse(jsonString2) : {}
  const [isReupload, setIsReupload] = useState<boolean>(false)

  // Add validation check for claimDetails at component mount
  useEffect(() => {
    // Check if claimDetails exists and contains the claim object
    if (!claimDetails || !claimDetails.claimDetails || !claimDetails.claimDetails.claim) {
      toast.error(`This claim is not found.`, {
        position: 'top-right',
        autoClose: 3000,
      })
      // Navigate back to claims page after showing toast
      setTimeout(() => {
        navigate('/claims')
      }, 1000)
      return
    }
  }, [claimDetails, navigate])

  // Debug function to track isReupload changes
  const setReuploadWithLogging = (value: boolean) => {
    console.log(`Setting isReupload from ${isReupload} to ${value}`)
    setIsReupload(value)
  }
  const [documentsStatus, setDocumentsStatus] = useState<{
    hasInvalid: boolean
    allUploaded: boolean
  }>({
    hasInvalid: false,
    allUploaded: false,
  })

  // Add new state to track document statuses
  const [documentStatuses, setDocumentStatuses] = useState<{
    [key: string]: {status: string; id: number; name: string; isArchive: boolean}
  }>({})

  console.log('documentStatuses', documentStatuses)

  // Add new state to track last notification
  const [lastNotification, setLastNotification] = useState<{
    label: string
    status: string
    timestamp: number
  } | null>(null)

  // Add this state at the top with other state declarations
  const [lastToastTime, setLastToastTime] = useState<number>(0)

  // Mirror of lastToastTime for the Pusher handler to read. The handler both reads
  // and sets lastToastTime, so keeping it in the Pusher effect's deps would rebuild
  // the client on every toast. See docs/plan/IDH-1620.
  const lastToastTimeRef = useRef<number>(lastToastTime)
  useEffect(() => {
    lastToastTimeRef.current = lastToastTime
  }, [lastToastTime])

  // Add area request flags
  const [hasDailyMonitoringRequest, setHasDailyMonitoringRequest] = useState<boolean>(false)
  const [monitoringDates, setMonitoringDates] = useState<string[]>([])
  const [hasDischargeRequest, setHasDischargeRequest] = useState<boolean>(false)

  // Add new state for button
  const [isButtonEnabled, setIsButtonEnabled] = useState<boolean>(false)
  const [isAttentionEnabled, setIsAttentionEnabled] = useState<boolean>(false)

  // Add state for diagnosis validation
  const [isDiagnosisValid, setIsDiagnosisValid] = useState<boolean>(false)

  // Add state for editing
  const [isEditing, setIsEditing] = useState<boolean>(false)

  // Add new state for button
  const [shouldEnableButton, setShouldEnableButton] = useState<boolean>(false)

  // Add new state for diagnosis data
  const [diagnosisData, setDiagnosisData] = useState<DiagnosisData>({})

  const {addClaimNumber, removeClaimNumber} = usePageData()

  // Add this state if not already present
  const [isChatModalOpen, setIsChatModalOpen] = useState<boolean>(false)

  // Add new state for documentsData
  const [documentsData, setDocumentsData] = useState<any[]>([])

  // Add new state for current status
  const [currentStatus, setCurrentStatus] = useState<string>(
    claimDetails?.claimDetails?.claim?.status || ''
  )

  // Add new state for IGL Superseding Request modal
  const [showSupersedingModal, setShowSupersedingModal] = useState<boolean>(false)
  const [supersedingRemark, setSupersedingRemark] = useState<string>('')
  const [showSupersedingRemarkError, setShowSupersedingRemarkError] = useState<boolean>(false)
  const [currentSupersedingType, setCurrentSupersedingType] = useState<string>('')
  
  const [categorySuperseding, setCategorySuperseding] = useState<string>('')
  const [showSupersedingCategoryError, setShowSupersedingCategoryError] = useState<boolean>(false)
  const [supersedingFiles, setSupersedingFiles] = useState<File[]>([])
  const supersedingFilesRef = React.useRef<File[]>([])
  supersedingFilesRef.current = supersedingFiles  // always in sync, no stale closure
  const statusSubmittedRef = React.useRef(false)
  const [showTrackingModal, setShowTrackingModal] = useState<boolean>(false)

  const {supersedingCycles} = useSupersedingCycles(claimDetails?.claimDetails?.claim?.claimNumber)
  const uploadSupersedingDocsMutation = useUploadSupersedingDocuments()

  const activeSupersedingCycle = supersedingCycles?.find(
    (c: any) =>
      (c.status !== 'Approved' && c.status !== 'Rejected') ||
      c.medicalEnquiries?.some((me: any) => !me.repliedAt)
  )
  const hasActiveSuperseding = !!activeSupersedingCycle

  // Add defaultDocuments constant
  const defaultDocuments = useMemo(
    () => [
      {label: 'Lembar Medis Awal', key: 0},
      {label: 'Copy KTP Pasien', key: 1},
      {label: 'Copy Kartu Asuransi Pasien', key: 2},
      {label: 'Surat Pernyataan (SP)', key: 3},
      {label: 'Medical Inquiry', key: 4},
      {label: 'Hasil Penunjang', key: 5},
    ],
    []
  )

  // Update validateDiagnosisFields to be more explicit
  const validateDiagnosisFields = (data: DiagnosisData): boolean => {
    if (!data) return false

    const isValid = !!(
      (
        data.mainDiagnosis?.trim() &&
        data.doctor?.trim() &&
        data.polyName?.trim() &&
        data.rencanaTindakan?.trim()
      )
      // data.losEstimation?.trim() &&
      // data.deposit?.trim()
    )

    return isValid
  }

  // Add handler for diagnosis data changes
  const handleDiagnosisDataChange = (newData: Partial<DiagnosisData>) => {
    const updatedData = {
      ...diagnosisData,
      ...newData,
      originalIcdCodes: {
        ...diagnosisData.originalIcdCodes,
        icd1: newData.icd1 || diagnosisData.originalIcdCodes?.icd1,
        icd2: newData.icd2 || diagnosisData.originalIcdCodes?.icd2,
        icd3: newData.icd3 || diagnosisData.originalIcdCodes?.icd3,
        icd4: newData.icd4 || diagnosisData.originalIcdCodes?.icd4,
      },
    }

    setDiagnosisData(updatedData)

    // Immediately validate the updated data
    const isValid = validateDiagnosisFields(updatedData)
    setIsDiagnosisValid(isValid)

    console.log('Diagnosis Validation:', {
      data: updatedData,
      isValid,
      fields: {
        mainDiagnosis: !!updatedData.mainDiagnosis?.trim(),
        icd1: !!(updatedData.originalIcdCodes?.icd1?.trim() || updatedData.icd1?.trim()),
        doctor: !!updatedData.doctor?.trim(),
        polyName: !!updatedData.polyName?.trim(),
        rencanaTindakan: !!updatedData.rencanaTindakan?.trim(),
      },
    })
  }

  const handleDocumentsClick = () => {
    setIsChatOpen(true)
  }

  const checkDocumentStatuses = useCallback(async () => {
    const claimNumber = claimDetails.claimDetails?.claim?.claimNumber
    const apiUrl = `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/ListFiles/${claimNumber}`

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
        },
      })

      if (response.data.isSuccess) {
        const documents = response.data.data

        // Define required document labels in both languages
        const admissionFormLabels = ['Lembar Medis Awal', 'Hospital Admission Form']
        const patientIdLabels = ['Copy KTP Pasien', 'Copy of Patient ID/Passport']
        const insuranceCardLabels = ['Copy Kartu Asuransi Pasien', 'Copy of Insurance Card']
        const statementLetterLabels = ['Surat Pernyataan (SP)', 'Declaration Letter']

        const requiredGroups = [
          admissionFormLabels,
          patientIdLabels,
          insuranceCardLabels,
          statementLetterLabels,
        ]

        // Check if all required groups have at least one uploaded document
        const allUploaded = requiredGroups.every((group) => {
          return group.some((label) => {
            const doc = documents.find((d: any) => d.label === label)
            return doc && doc.document && doc.document.length > 0
          })
        })

        // Check if any document has INVALID status
        const hasInvalid = documents.some((doc: any) => {
          if (doc.label === 'Prescription') return false
          return (
            doc.document &&
            doc.document.length > 0 &&
            doc.document.some(
              (file: any) =>
                file.status === 'INVALID' ||
                file.status === 'Request Document' ||
                file.status === 'REQUEST'
            )
          )
        })

        setDocumentsUploaded(allUploaded && !hasInvalid)
        setDocumentsStatus({
          hasInvalid,
          allUploaded,
        })

        // console.log('Document Status Check:', {
        //   allUploaded,
        //   hasInvalid,
        //   documents: documents.map((d: any) => ({
        //     label: d.label,
        //     status: d.document?.[0]?.status
        //   }))
        // });
      }
    } catch (error) {
      console.error('Error checking document statuses:', error)
    } finally {
      setDocumentsChecked(true)
    }
  }, [claimDetails.claimDetails?.claim?.claimNumber, auth?.token, user.currentUser?.token])

  const debouncedFetch = useMemo(
    () =>
      debounce(async () => {
        await checkDocumentStatuses()
      }, 1000),
    [checkDocumentStatuses]
  ) // 1 second delay

  useEffect(() => {
    if (status === 'Registered' || status === 'Pre-Registered') {
      setIsEditingDiagnosis(true)
    } else {
      setIsEditingDiagnosis(false)
    }
  }, [status])

  const handleDocumentsStatusChange = useCallback(
    (statusDoc: boolean) => {
      console.log('Documents status changed:', statusDoc)
      setDocumentsUploaded(statusDoc)
      setDocumentsChecked(true)
      setIsDataValid(statusDoc)
      setIsAttentionEnabled(statusDoc)

      // Immediately update button state
      const currentClaimStatus = claimDetails.claimDetails?.claim?.status
      const validStatus = ['Registered', 'Pre-Registered', 'Pending on IGL'].includes(
        currentClaimStatus
      )
      const shouldEnable = statusDoc && isDiagnosisValid && validStatus
      console.log('shouldEnable: ', shouldEnable)
      console.log('shouldEnable: ', {
        status: statusDoc,
        isDiagnosisValid,
        validStatus,
      })
      setIsButtonEnabled(shouldEnable)
      setShouldEnableButton(shouldEnable)
      // setShouldEnableButton(false)
      setGlobalAttention(
        shouldEnable,
        claimDetails.claimDetails?.claim?.claimNumber,
        currentClaimStatus
      )
    },
    [
      claimDetails.claimDetails?.claim?.status,
      claimDetails.claimDetails?.claim?.claimNumber,
      isDiagnosisValid,
    ]
  )

  const handleDocumentRealtimeUpdate = useCallback(
    (data: any) => {
      console.log('Document realtime update received:', data)
      if (data.isSuccess) {
        const apiDocuments = data.data.filter((doc: any) => doc.label !== 'Prescription')

        // Check document statuses - IDLE should be considered acceptable
        const hasInvalidDocuments = apiDocuments.some(
          (doc: any) =>
            doc.document &&
            doc.document.length > 0 &&
            doc.document.some(
              (file: any) => file.status === 'INVALID' || file.status === 'Request Document'
            )
        )

        const allDocumentsUploaded = defaultDocuments.every((defaultDoc) =>
          apiDocuments.some(
            (apiDoc) =>
              apiDoc.label === defaultDoc.label && apiDoc.document && apiDoc.document.length > 0
          )
        )

        // Check if all documents have acceptable status (not INVALID or Request Document)
        const allDocumentsValidStatus = apiDocuments.every(
          (doc: any) =>
            doc.document &&
            doc.document.length > 0 &&
            doc.document.every(
              (file: any) => file.status !== 'INVALID' && file.status !== 'Request Document'
            )
        )

        // Update states immediately
        const validStatus = ['Registered', 'Pre-Registered', 'Pending on IGL'].includes(status)
        const shouldEnable =
          allDocumentsUploaded &&
          !hasInvalidDocuments &&
          allDocumentsValidStatus &&
          isDiagnosisValid &&
          validStatus

        setDocumentsUploaded(allDocumentsUploaded)
        setIsDataValid(!hasInvalidDocuments)
        setIsButtonEnabled(shouldEnable)
        setShouldEnableButton(shouldEnable)
        setIsAttentionEnabled(shouldEnable)
        setGlobalAttention(shouldEnable, claimDetails.claimDetails?.claim?.claimNumber, status)

        console.log('Real-time button state update:', {
          allDocumentsUploaded,
          hasInvalidDocuments,
          allDocumentsValidStatus,
          isDiagnosisValid,
          validStatus,
          shouldEnable,
        })
      }
    },
    [claimDetails.claimDetails?.claim?.claimNumber, status, isDiagnosisValid, defaultDocuments]
  )

  // const handleDocumentRealtimeUpdate = (data: any) => {
  //   console.log('Document realtime update received:', data)
  //   if (data.isSuccess) {
  //     const apiDocuments = data.data.filter((doc: any) => doc.label !== 'Prescription')

  //     // Check document statuses
  //     const hasInvalidDocuments = apiDocuments.some(
  //       (doc: any) =>
  //         doc.document &&
  //         doc.document.length > 0 &&
  //         doc.document.some((file: any) => file.status === 'INVALID')
  //     )

  //     const allDocumentsUploaded = defaultDocuments.every((defaultDoc) =>
  //       apiDocuments.some(
  //         (apiDoc) =>
  //           apiDoc.label === defaultDoc.label && apiDoc.document && apiDoc.document.length > 0
  //       )
  //     )

  //     const allDocumentsIdle = apiDocuments.every(
  //       (doc: any) =>
  //         doc.document &&
  //         doc.document.length > 0 &&
  //         doc.document.every(
  //           (file: any) => file.status === 'IDLE' || file.status === 'Request Document'
  //         )
  //     )

  //     // Update states
  //     const validStatus = ['Registered', 'Pre-Registered', 'Pending on IGL'].includes(
  //       claimDetails.claimDetails.claim.status
  //     )
  //     const shouldEnable =
  //       allDocumentsUploaded &&
  //       !hasInvalidDocuments &&
  //       allDocumentsIdle &&
  //       isDiagnosisValid &&
  //       validStatus

  //     setDocumentsUploaded(allDocumentsUploaded)
  //     setIsDataValid(!hasInvalidDocuments)
  //     setIsButtonEnabled(shouldEnable)
  //     setShouldEnableButton(shouldEnable)
  //     setIsAttentionEnabled(shouldEnable)
  //     setGlobalAttention(shouldEnable, claimDetails.claimDetails.claim.claimNumber)
  //   }
  // }

  console.log('isReupload', isReupload)

  useEffect(() => {
    console.log('useEffect with isReupload triggered, isReupload value:', isReupload)

    // Only fetch data when isReupload is true to avoid unnecessary API calls
    if (!isReupload) {
      console.log('isReupload is false, returning early')
      return
    }

    console.log('inpatient page wrapper - fetching data due to reupload')
    console.log('isReupload', isReupload)

    const fetchDataDischarge = async () => {
      const claimNumber = claimDetails.claimDetails?.claim?.claimNumber
      const apiUrl = `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/ListFiles/${claimNumber}?area=Discharge`
      try {
        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
          },
        })
        if (response.data.isSuccess) {
          console.log('API response data:', response.data.data)
          console.log('Setting documentsData to:', response.data.data)
          setDocumentsData(response.data.data)

          // Also update documentStatuses to keep both states in sync
          const newDocumentStatuses: {
            [key: string]: {status: string; id: number; name: string; isArchive: boolean}
          } = {}
          response.data.data.forEach((doc: any) => {
            if (doc.document?.[0]) {
              newDocumentStatuses[doc.label] = {
                status: doc.document[0].status,
                id: doc.document[0].id,
                name: doc.document[0].name,
                isArchive: doc.document[0].isArchive,
              }
            }
          })
          console.log('Updated documentStatuses:', newDocumentStatuses)
          console.log('Setting documentStatuses to:', newDocumentStatuses)
          setDocumentStatuses(newDocumentStatuses)

          // Reset isReupload after successful fetch to prevent infinite loops
          // Use setTimeout to ensure state updates are processed before resetting
          setTimeout(() => {
            console.log('Resetting isReupload to false after successful fetch')
            setReuploadWithLogging(false)
          }, 500)
        } else {
          console.error('Failed to fetch documents:', response.data.message)
          // Reset isReupload even on failure to prevent infinite loops
          // Use setTimeout to ensure state updates are processed before resetting
          setTimeout(() => {
            console.log('Resetting isReupload to false after failed fetch')
            setIsReupload(false)
          }, 500)
        }
      } catch (error) {
        console.error('Error fetching documents:', error)
        // Reset isReupload even on error to prevent infinite loops
        // Use setTimeout to ensure state updates are processed before resetting
        setTimeout(() => {
          console.log('Resetting isReupload to false after error')
          setIsReupload(false)
        }, 500)
      }
    }

    fetchDataDischarge()
  }, [
    isReupload,
    claimDetails.claimDetails?.claim?.claimNumber,
    auth?.token,
    user.currentUser?.token,
  ])

  useEffect(() => {
    // Skip this useEffect if isReupload is true to avoid conflicts
    if (isReupload) {
      console.log('Skipping claimDetails useEffect because isReupload is true')
      return
    }

    console.log('inpatient page wrapper - useEffect with claimDetails dependency')
    const fetchDataDischarge = async () => {
      const claimNumber = claimDetails.claimDetails?.claim?.claimNumber
      const apiUrl = `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/ListFiles/${claimNumber}?area=Discharge`
      console.log('Fetching data from claimDetails useEffect:', apiUrl)
      try {
        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
          },
        })
        if (response.data.isSuccess) {
          console.log('claimDetails useEffect - setting documentsData:', response.data.data)
          setDocumentsData(response.data.data)
        } else {
          console.error('Failed to fetch documents:', response.data.message)
        }
      } catch (error) {
        console.error('Error fetching documents:', error)
      }
    }

    fetchDataDischarge()
  }, [claimDetails, isReupload])

  useEffect(() => {
    console.log('inpatient page wrapper')
    const fetchData = async () => {
      const claimNumber = claimDetails.claimDetails?.claim?.claimNumber
      const apiUrl = `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/ListFiles/${claimNumber}`
      try {
        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
          },
        })
        if (response.data.isSuccess) {
          setValidationData(response.data.data)
          validateDocuments(response.data.data)
        } else {
          console.error('Failed to fetch documents:', response.data.message)
        }
      } catch (error) {
        console.error('Error fetching documents:', error)
      }
    }

    fetchData()
  }, [claimDetails])

  useEffect(() => {
    // console.log("Current View: ", currentView);
  }, [currentView])

  const validateDocuments = (data: any[]) => {
    // Filter out Prescription documents first
    const relevantDocuments = data.filter((doc) => doc.label !== 'Prescription')

    // Check if any document has INVALID status
    const hasInvalidDocuments = relevantDocuments.some(
      (doc) =>
        doc.document &&
        doc.document.length > 0 &&
        doc.document.some((file) => file.status === 'INVALID' || file.status === 'Request Document')
    )

    // Check if all required documents are present and uploaded (both languages)
    const admissionFormLabels = ['Lembar Medis Awal', 'Hospital Admission Form']
    const patientIdLabels = ['Copy KTP Pasien', 'Copy of Patient ID/Passport']
    const insuranceCardLabels = ['Copy Kartu Asuransi Pasien', 'Copy of Insurance Card']
    const statementLetterLabels = ['Surat Pernyataan (SP)', 'Declaration Letter']

    const requiredGroups = [
      admissionFormLabels,
      patientIdLabels,
      insuranceCardLabels,
      statementLetterLabels,
    ]

    const hasAllDocuments = requiredGroups.every((group) =>
      group.some((label) =>
        relevantDocuments.some(
          (item) => item.label === label && item.document && item.document.length > 0
        )
      )
    )

    setDocumentsUploaded(hasAllDocuments && !hasInvalidDocuments)
    setIsDataValid(hasAllDocuments && !hasInvalidDocuments)
    setDocumentsChecked(true)
  }

  const handleEditClick = () => {
    setIsEditingDiagnosis(true)
  }

  const handleDocumentClick = (docLabel: string) => {
    setChatMessage(docLabel)
    setIsChatOpen(true)
  }

  const handleRequestIGL = async (e: React.FormEvent) => {
    e.preventDefault()

    if (status !== 'Pre-Registered' && status !== 'Pending on IGL') {
      return
    }

    // Disable attention message immediately
    setIsAttentionEnabled(false)
    setGlobalAttention(false, claimDetails.claimDetails.claim.claimNumber, status)

    setLoading(true)
    try {
      // Clear unsaved diagnosis draft on IGL request
      const claimNo = claimDetails?.claimDetails?.claim?.claimNumber
      if (claimNo) sessionStorage.removeItem(`diagnosisDraft:${claimNo}`)

      if (status === 'Pre-Registered') {
        if (parsedJson?.Deposit) {
          await updateClaimStatus()
        } else {
          await saveDiagnosisData()
          await updateClaimStatus()
        }
        navigate('/claims')
      } else if (status === 'Pending on IGL') {
        await updateClaimStatus()
        navigate('/claims')
      }
    } catch (error) {
      console.error('Error in handleRequestIGL:', error)
      handleError(error)
      // Re-enable attention on error
      setIsAttentionEnabled(true)
      setGlobalAttention(true, claimDetails.claimDetails.claim.claimNumber, status)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {}, [diagnosisData])

  // Helper function to save diagnosis data
  const saveDiagnosisData = async () => {
    const existingData = claimDetails.claimDetails.claim.claimData
    const parsedExistingData = existingData ? JSON.parse(existingData) : {}

    const depositStr = diagnosisData.deposit || parsedExistingData?.Deposit || '0'
    const depositValue = parseFloat(depositStr.replace(/\./g, '').replace(/,/g, '.'))

    const payload = {
      claimNo: claimDetails?.claimDetails?.claim?.claimNumber,
      icdCode1: diagnosisData.originalIcdCodes?.icd1 || parsedJson2?.IcdCode1 || '',
      icdCode2: diagnosisData.originalIcdCodes?.icd2 || parsedJson2?.IcdCode2 || '',
      icdCode3: diagnosisData.originalIcdCodes?.icd3 || parsedJson2?.IcdCode3 || '',
      icdCode4: diagnosisData.originalIcdCodes?.icd4 || parsedJson2.icdCode4 || '',
      doctor: diagnosisData.doctor || parsedExistingData?.Doctor || '',
      polyName: diagnosisData.polyName || parsedExistingData?.PolyName || '',
      remark: diagnosisData.remark || parsedExistingData?.Remark || '',
      deposit: depositValue,
      treatmentPlan: diagnosisData.rencanaTindakan || parsedExistingData?.TreatmentPlan || '',
      los: diagnosisData.losEstimation
        ? parseInt(diagnosisData.losEstimation)
        : parseInt(parsedExistingData?.Los) || 0,
      updatedBy: user.currentUser?.email,
      indate:
        diagnosisData.indate !== undefined
          ? diagnosisData.indate
          : claimDetails?.claimDetails?.claim?.indate || '',
      BenefitDetail: {
        id: parsedJson?.Id,
        benefitName: parsedJson?.BenefitName,
        planName: parsedJson?.PlanName,
        benefitCode: parsedJson?.BenefitCode,
        condition: parsedJson?.Condition,
        annualLimit: parsedJson?.AnnualLimit,
        subBenefits:
          parsedJson?.SubBenefits?.map((subBenefit: any) => ({
            id: subBenefit.Id,
            category: 'INPATIENT',
            SubBenefitName: subBenefit.SubBenefitName,
            isCashless: subBenefit.IsCashless,
            isReimburstement: subBenefit.IsReimburstement,
            annualLimit: subBenefit.AnnualLimit,
            type: subBenefit.Type,
            claimValue: subBenefit.ClaimValue,
            details: subBenefit.Details,
            condition: subBenefit?.Condition || [],
            isAsCharge: subBenefit.IsAsCharge,
          })) || [],
      },
    }

    // console.log('Payload:', JSON.stringify(payload, null, 2));

    const headers = {
      Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
    }

    const response = await axios.post(
      `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/Provider/ProcessClaim/INPATIENT`,
      payload,
      {headers}
    )

    if (!response.data.isSuccess) {
      throw new Error('Failed to save diagnosis data')
    }

    toast.success('IGL Request submitted successfully!', {
      position: 'top-right',
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: 'light',
    })

    // Clear unsaved diagnosis draft on successful save
    const claimNo = claimDetails?.claimDetails?.claim?.claimNumber
    if (claimNo) sessionStorage.removeItem(`diagnosisDraft:${claimNo}`)

    setIsEditing(false)
  }

  // Helper function to update claim status
  const updateClaimStatus = async () => {
    const apiUrl = `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/UpdateStatus`
    const payload = {
      claimNumber: claimDetails.claimDetails.claim.claimNumber,
      status: 'Request IGL',
      username: user.currentUser?.email,
      source: 'Provider',
    }
    const headers = {
      Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
    }

    const response = await axios.post(apiUrl, payload, {headers})

    if (!response.data.isSuccess) {
      throw new Error('Failed to submit IGL Request')
    }

    // Clear recently uploaded tracking on successful submission
    sessionStorage.removeItem('recentlyUploadedLabels')

    // Invalidate and refetch claims queries to update the UI
    queryClient.invalidateQueries(['claims'])
    queryClient.invalidateQueries(['myTurnTotal'])

    toast.success('IGL Request submitted successfully!', {
      position: 'bottom-right',
      autoClose: 3000,
    })
  }

  const updateClaimStatusSupersedingRequest = async (
    status: string,
    remark: string = 'Superseding Request',
    category: string = ''
  ) => {
    const apiUrl = `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/UpdateStatus`
    const payload = {
      claimNumber: claimDetails.claimDetails.claim.claimNumber,
      status:
        status === 'IGL' || status === 'Daily Monitoring'
          ? 'IGL Superseding Request'
          : 'FGL Superseding Request',
      username: user.currentUser?.email,
      source: 'Provider',
      remarkSuperseeding: remark,
      categorySuperseding: category,
    }
    const headers = {
      Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
    }

    const response = await axios.post(apiUrl, payload, {headers})

    if (!response.data.isSuccess) {
      throw new Error('Failed to submit IGL Request')
    }

    // Invalidate and refetch claims queries to update the UI
    queryClient.invalidateQueries(['claims'])
    queryClient.invalidateQueries(['myTurnTotal'])

    toast.success('IGL Request submitted successfully!', {
      position: 'bottom-right',
      autoClose: 3000,
    })
  }

  const updateClaimStatusMedicalInquiry = async () => {
    const apiUrl = `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/UpdateStatus`
    const payload = {
      claimNumber: claimDetails.claimDetails.claim.claimNumber,
      status: 'Submit Enquiry Response',
      username: user.currentUser?.email,
      source: 'Provider',
    }
    const headers = {
      Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
    }

    const response = await axios.post(apiUrl, payload, {headers})

    if (!response.data.isSuccess) {
      throw new Error('Failed to  Medical Inquiry')
    }

    // Invalidate and refetch claims queries to update the UI
    queryClient.invalidateQueries(['claims'])
    queryClient.invalidateQueries(['myTurnTotal'])

    toast.success('Medical Inquiry submitted successfully!', {
      position: 'bottom-right',
      autoClose: 3000,
    })
    navigate('/claims')
  }

  const updateClaimStatusFGLReviewWhenPending = async () => {
    const apiUrl = `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/UpdateStatus`
    const payload = {
      claimNumber: claimDetails.claimDetails.claim.claimNumber,
      status: 'FGL Review',
      username: user.currentUser?.email,
      source: 'Provider',
    }
    const headers = {
      Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
    }

    const response = await axios.post(apiUrl, payload, {headers})

    if (!response.data.isSuccess) {
      throw new Error('Failed to submit IGL Request')
    }

    // Invalidate and refetch claims queries to update the UI
    queryClient.invalidateQueries(['claims'])
    queryClient.invalidateQueries(['myTurnTotal'])

    // Clear recently uploaded tracking on successful submission
    sessionStorage.removeItem('recentlyUploadedLabels')

    toast.success('FGL Review submitted successfully!', {
      position: 'bottom-right',
      autoClose: 3000,
    })
    navigate('/claims')
  }

  // Helper function to handle errors
  const handleError = (error: any) => {
    const errorMessage = error.response?.data?.message || error.message || 'An error occurred'

    toast.error(errorMessage, {
      position: 'bottom-right',
      autoClose: 3000,
    })
  }

  // Update initial view and active key based on status
  useEffect(() => {
    if (
      status === 'FGL RELEASED' ||
      status === 'FGL Released' ||
      status === 'Request FGL' ||
      status === 'Final Document Complete' ||
      status === 'FGL Review' ||
      status === 'Pending on FGL'
    ) {
      setCurrentView('discharged')
      setView('discharged')
      setActiveKey('discharged')
    }
  }, [status])

  // Update the visibility conditions for prev/next buttons
  const showPrevButton =
    status === 'FGL RELEASED' ||
    status === 'FGL Released' ||
    status === 'Request FGL' ||
    status === 'Final Document Complete' ||
    status === 'FGL Review' ||
    status === 'Pending on FGL' ||
    ((status === 'IGL RELEASED' || status === 'Daily Monitoring' || status === 'IGL Released') &&
      currentView === 'calendar')

  const showNextButton =
    // Show next button on inpatient view for FGL statuses
    ((status === 'FGL RELEASED' ||
      status === 'FGL Released' ||
      status === 'Request FGL' ||
      status === 'Final Document Complete' ||
      status === 'FGL Review' ||
      status === 'Pending on FGL') &&
      currentView === 'inpatient') ||
    // Show next button for IGL/Daily Monitoring statuses on inpatient
    ((status === 'IGL RELEASED' || status === 'Daily Monitoring' || status === 'IGL Released') &&
      currentView === 'inpatient') ||
    // Show next button on calendar view for FGL statuses
    ((status === 'FGL RELEASED' ||
      status === 'FGL Released' ||
      status === 'Request FGL' ||
      status === 'Final Document Complete' ||
      status === 'FGL Review' ||
      status === 'Pending on FGL') &&
      currentView === 'calendar')

  // Update the navigation handler
  const handleViewNavigation = (direction: 'prev' | 'next') => {
    if (
      status === 'FGL RELEASED' ||
      status === 'FGL Released' ||
      status === 'Request FGL' ||
      status === 'Final Document Complete' ||
      status === 'FGL Review' ||
      status === 'Pending on FGL'
    ) {
      if (currentView === 'discharged') {
        if (direction === 'prev') {
          setCurrentView('calendar')
          setView('calendar')
          setActiveKey('calendar')
        }
      } else if (currentView === 'calendar') {
        if (direction === 'prev') {
          setCurrentView('inpatient')
          setView('inpatient')
          setActiveKey('diagnosis')
        } else if (direction === 'next') {
          setCurrentView('discharged')
          setView('discharged')
          setActiveKey('discharged')
        }
      } else if (currentView === 'inpatient') {
        if (direction === 'next') {
          setCurrentView('calendar')
          setView('calendar')
          setActiveKey('calendar')
        }
      }
    } else if (
      status === 'IGL RELEASED' ||
      status === 'Daily Monitoring' ||
      status === 'IGL Released'
    ) {
      if (direction === 'next') {
        setCurrentView('calendar')
        setView('calendar')
        setActiveKey('calendar')
      } else if (direction === 'prev') {
        setCurrentView('inpatient')
        setView('inpatient')
        setActiveKey('diagnosis')
      }
    }
  }

  useEffect(() => {
    if (status === 'Request IGL') {
      // console.log('View changed to:', view);
      if (view === 'calendar') {
        setActiveKey('calendar')
      } else if (view === 'inpatient') {
        setActiveKey('diagnosis')
      }
    } else if (status === 'Request FGL') {
      if (view === 'discharged') {
        setActiveKey('discharged')
      }
    }
  }, [view, status])

  useEffect(() => {
    // console.log('View changed to:', currentView);
  }, [currentView])

  useEffect(() => {
    const pusher = createPusherClient('InpatientWrapper')

    const claimNumber = claimDetails.claimDetails?.claim?.claimNumber

    // Subscribe to list-file-channel
    const listFileChannel = pusher.subscribe(`list-file-channel-${claimNumber}`)

    // Subscribe to file-channel-{claimNumber}
    const fileStatusChannel = pusher.subscribe(`file-channel-${claimNumber}`)

    console.log('fileStatusChannel', fileStatusChannel)

    // Handle list-file updates
    listFileChannel.bind(`get-list-${claimNumber}`, (data: any) => {
      // console.log("Received list file data:", data);
      setDocumentRealtime(data)

      if (data.isSuccess) {
        const apiDocuments = data.data.filter((doc: any) => doc.label !== 'Prescription')

        // Update documentsData for FGL button reactivity
        setDocumentsData(data.data)

        // Update states as before
        setDocumentStatuses((prev) => {
          const newDocumentStatuses = {...prev}
          apiDocuments.forEach((doc: any) => {
            if (doc.document?.[0]) {
              newDocumentStatuses[doc.label] = {
                status: doc.document[0].status,
                id: doc.document[0].id,
                name: doc.document[0].name,
                isArchive: doc.document[0].isArchive,
              }
            }
          })
          return newDocumentStatuses
        })
      }
    })

    // Handle individual file status updates
    fileStatusChannel.bind(`get-${claimNumber}`, (data: any) => {
      if (data && data.message) {
        const {message} = data
        const {Label, Status, Id, DocumentName, isArchive, UpdatedBy} = message

        // Update document statuses
        setDocumentStatuses((prev) => {
          const newStatuses = {
            ...prev,
            [Label]: {
              status: Status,
              id: Id,
              name: DocumentName,
              isArchive: isArchive,
            },
          }

          // Check required documents
          const requiredLabels = [
            'Lembar Medis Awal',
            'Copy KTP Pasien',
            'Copy Kartu Asuransi Pasien',
            'Surat Pernyataan (SP)',
            'Medical Inquiry',
            'Hasil Penunjang',
            'Resume Medis',
            'Billing Akhir',
            'Hasil Penunjang',
          ]

          // Check if any document has INVALID status
          const hasInvalidDocuments = Object.values(newStatuses).some(
            (doc: any) => doc.status === 'INVALID' || doc.status === 'Request Document'
          )

          console.log('hasInvalidDocuments', hasInvalidDocuments)

          // Check if all required documents are uploaded (regardless of status)
          const allRequiredUploaded = requiredLabels.every(
            (label) => newStatuses[label] !== undefined
          )

          // Update states immediately
          setDocumentsUploaded(allRequiredUploaded)
          setIsDataValid(!hasInvalidDocuments)

          return newStatuses
        })

        // Handle toast notifications with debouncing
        const now = Date.now()
        if (
          Status === 'INVALID' ||
          (Status === 'Request Document' && now - lastToastTimeRef.current > 5000)
        ) {
          // Clear any existing toasts first
          toast.dismiss()

          toast.error(`${Label} has been rejected by ${UpdatedBy}. Please review and resubmit.`, {
            position: 'top-right',
            autoClose: 3000,
          })
          setLastToastTime(now)
        }
      }
    })

    // Debug subscriptions
    // console.log("Subscribed to channels:", {
    //   listChannel: `list-file-channel-${claimNumber}`,
    //   fileChannel: `file-channel-${claimNumber}`,
    //   fileEvent: `get-${claimNumber}`
    // });

    return () => {
      listFileChannel.unbind_all()
      fileStatusChannel.unbind_all()
      pusher.unsubscribe(`list-file-channel-${claimNumber}`)
      pusher.unsubscribe(`file-channel-${claimNumber}`)
      pusher.disconnect()
    }
  }, [claimDetails.claimDetails?.claim?.claimNumber])

  // Add debug logging
  useEffect(() => {
    const checkAndUpdateDocuments = async () => {
      if (documentStatuses && typeof documentStatuses === 'object') {
        // Check if any document has INVALID status
        const hasInvalidStatus = Object.values(documentStatuses).some(
          (doc: DocumentStatus) =>
            doc.status === 'INVALID' || doc.status === 'IDLE' || doc.status === 'Request Document'
        )

        // console.log("Document Status Check:", {
        //   currentStatus: documentStatuses,
        //   hasInvalidStatus,
        //   documentDetails: Object.entries(documentStatuses).map(([label, doc]) => ({
        //     label,
        //     status: doc.status
        //   })),
        //   timestamp: new Date().toISOString()
        // });

        // Only trigger fetch if status is changing to INVALID or IDLE
        const statusChanged = Object.values(documentStatuses).some(
          (doc) =>
            doc.status === 'INVALID' || doc.status === 'IDLE' || doc.status === 'Request Document'
        )

        if (statusChanged) {
          debouncedFetch()
        }
      }
    }

    checkAndUpdateDocuments()
    setIncomingsinglefile(documentStatuses)

    // console.log("Current document statuses:", documentStatuses);

    // Cleanup
    return () => {
      debouncedFetch.cancel()
    }
  }, [documentStatuses, debouncedFetch]) // Remove isDataValid and documentsStatus from dependencies

  useEffect(() => {
    // console.log("Component re-rendered. Current notification count:", notificationCount, "New notification:", hasNewNotification);
  }, [notificationCount, hasNewNotification])

  // Set default view based on status
  useEffect(() => {
    // if (status === 'IGL RELEASED') {
    //   setCurrentView('inpatient')
    //   setActiveKey('diagnosis')
    // } else if (status === 'Daily Monitoring') {
    //   setCurrentView('calendar')
    //   setActiveKey('calendar')
    // }
    if (status === 'IGL RELEASED' || status === 'IGL Released' || status === 'Daily Monitoring') {
      setCurrentView('calendar')
      setActiveKey('calendar')
    }
  }, [status])

  const isMonitoringOrFGL = status === 'Daily Monitoring' || status === 'Request FGL'

  useEffect(() => {
    if (['Registered', 'Pre-Registered', 'Pending on IGL'].includes(status)) {
      checkDocumentStatuses()
    }
  }, [status, checkDocumentStatuses])

  const canRequestIGL = useMemo(() => {
    // Check if there are required documents (explicitly filter out Prescription)
    const relevantDocuments = documentRealtime?.message?.Data?.filter(
      (doc: any) => doc.Label !== 'Prescription'
    )

    // Check if we have all 6 required documents
    const hasAllRequiredDocuments = relevantDocuments?.length >= 4

    const validStatus = ['Registered', 'Pre-Registered', 'Pending on IGL'].includes(status)
    const validDocuments =
      hasAllRequiredDocuments && documentsUploaded && !documentsStatus.hasInvalid

    return isDataValid && validStatus && validDocuments
  }, [
    documentRealtime?.message?.Data,
    status,
    documentsUploaded,
    documentsStatus.hasInvalid,
    isDataValid,
  ])

  const getRequestIGLWarnings = (): string[] => {
    const warnings: string[] = []

    // Helper function to safely check values
    const isValidValue = (value: any): boolean => {
      if (value === null || value === undefined) return false
      if (typeof value === 'number') return true
      if (typeof value === 'string') return value.trim().length > 0
      return false
    }

    // Check diagnosis data first
    // const diagnosisFields = {
    //   'Diagnosa Utama': diagnosisData?.mainDiagnosis,
    //   'Nama Dokter': diagnosisData?.doctor,
    //   'Nama Poli': diagnosisData?.polyName,
    //   'Rencana Tindakan': diagnosisData?.rencanaTindakan,
    //   // 'Rencana Lama Rawat Inap': diagnosisData?.losEstimation,
    //   // Deposit: diagnosisData?.deposit,
    // }

    const diagnosisFields = {
      [f({id: 'CLAIM.INPATIENT.DIAGNOSIS_MAIN'})]: diagnosisData?.mainDiagnosis,
      [f({id: 'CLAIM.INPATIENT.DOCTOR_NAME'})]: diagnosisData?.doctor,
      [f({id: 'CLAIM.INPATIENT.POLI_NAME'})]: diagnosisData?.polyName,
      [f({id: 'CLAIM.INPATIENT.TREATMENT_PLAN'})]: diagnosisData?.rencanaTindakan,
      // [f({id: 'CLAIM.INPATIENT.LOS_ESTIMATION'})]: diagnosisData?.losEstimation,
      // [f({id: 'CLAIM.INPATIENT.DEPOSIT'})]: diagnosisData?.deposit,
    }

    const missingFields = Object.entries(diagnosisFields)
      .filter(([_, value]) => !isValidValue(value))
      .map(([field]) => field)

    if (missingFields.length > 0) {
      warnings.push(...missingFields)
    }

    // Check documents
    if (!documentsUploaded || !isDataValid || documentsStatus.hasInvalid) {
      warnings.push(f({id: 'CLAIM.INPATIENT.DOCUMENT_NOT_UPLOADED'}))
    }

    return warnings
  }

  const handleDownloadIGL = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_CLAIM_URL}/api/Attachment/DownloadIGL/${claimDetails.claimDetails?.claim?.claimNumber}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
          },
        }
      )

      if (!response.ok) {
        throw new Error('Failed to fetch IGL document')
      }

      const data = await response.json()

      if (data && data.url) {
        // Open URL in new tab to trigger download
        window.open(data.url, '_blank')

        toast.success('IGL download started!', {
          position: 'top-right',
          autoClose: 3000,
        })
      } else {
        throw new Error('Invalid response format')
      }
    } catch (error) {
      console.error('Error downloading IGL:', error)
      toast.error('Failed to download IGL', {
        position: 'top-right',
        autoClose: 3000,
      })
    }
  }

  const handleDownloadFGL = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_CLAIM_URL}/api/Attachment/DownloadFGL/${claimDetails.claimDetails?.claim?.claimNumber}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
          },
        }
      )

      if (!response.ok) {
        throw new Error('Failed to fetch FGL document')
      }

      const data = await response.json()

      if (data && data.url) {
        // Open URL in new tab to trigger download
        window.open(data.url, '_blank')

        toast.success('FGL download started!', {
          position: 'top-right',
          autoClose: 3000,
        })
      } else {
        throw new Error('Invalid response format')
      }
    } catch (error) {
      console.error('Error downloading FGL:', error)
      toast.error('Failed to download FGL', {
        position: 'top-right',
        autoClose: 3000,
      })
    }
  }

  // console.log('Document Realtime:', JSON.stringify(documentRealtime, null, 2));

  // Update the useEffect for button state
  useEffect(() => {
    const validStatus = ['Registered', 'Pre-Registered', 'Pending on IGL'].includes(status)

    // Button enables if status is valid, documents are all uploaded, none are invalid, and diagnosis is valid
    const canEnable =
      validStatus && documentsUploaded && !documentsStatus.hasInvalid && isDiagnosisValid

    setShouldEnableButton(canEnable)
    setIsButtonEnabled(canEnable)
    setIsAttentionEnabled(canEnable)
    setGlobalAttention(canEnable, claimDetails.claimDetails?.claim?.claimNumber, status)

    console.log('IGL Button Calculation:', {
      validStatus,
      documentsUploaded,
      hasInvalid: documentsStatus.hasInvalid,
      isDiagnosisValid,
      canEnable,
    })
  }, [
    status,
    documentsUploaded,
    documentsStatus.hasInvalid,
    isDiagnosisValid,
    documentRealtime?.message?.Data, // Keep as dependency for Pusher reactivity
  ])

  const canRequestFGL = useMemo(() => {
    console.log('=== canRequestFGL useMemo triggered ===')
    console.log('documentsData: ', documentsData)
    console.log('documentStatuses: ', documentStatuses)
    console.log('documentsData length:', documentsData?.length || 0)
    console.log('documentStatuses keys:', Object.keys(documentStatuses || {}))

    // Check if documentsData is defined and is an array
    if (!Array.isArray(documentsData)) {
      console.log('documentsData is not an array, returning false')
      return false
    }

    // Log the entire documentsData for debugging

    // Check for the "Resume Medis", "Billing Akhir", and "Hasil Penunjang" labels
    const resumeMedisDoc = documentsData.find(
      (doc) => doc.label === 'Resume Medis' || doc.label === 'Discharge Summary'
    )
    const billingAkhirDoc = documentsData.find(
      (doc) => doc.label === 'Billing Akhir' || doc.label === 'Final Bill'
    )
    const hasilPenunjangDoc = documentsData.find(
      (doc) => doc.label === 'Hasil Penunjang' || doc.label === 'Supporting Document' || doc.label === 'Hasil Penunjang Medis'
    )
    // Check if there are any documents with status "INVALID" or "Request Document" in documentsData
    const hasInvalidDocumentsData = documentsData.some(
      (doc) =>
        doc.document &&
        doc.document.some((file) => file.status === 'INVALID' || file.status === 'Request Document')
    )

    // Check if there are any documents with status "INVALID" in documentStatuses
    const hasInvalidDocumentStatuses = Object.values(documentStatuses).some(
      (doc: any) => doc.status === 'INVALID' || doc.status === 'Request Document'
    )

    // Combined check for invalid documents
    const hasInvalidDocuments = hasInvalidDocumentsData || hasInvalidDocumentStatuses

    // Enable the button if there are no invalid documents and all required documents are uploaded
    const result =
      !hasInvalidDocuments &&
      resumeMedisDoc &&
      resumeMedisDoc.document.length > 0 &&
      billingAkhirDoc &&
      billingAkhirDoc.document.length > 0 &&
      hasilPenunjangDoc &&
      hasilPenunjangDoc.document.length > 0

    return result
  }, [documentsData, documentStatuses])

  const handleRequestFGL = () => {
    if (status === 'Pending on FGL') {
      updateClaimStatus()
    } else if (status === 'Daily Monitoring') {
      setShowFGLModal(true)
    }
  }

  // Add handler for status updates
  useEffect(() => {
    const fetchLatestStatus = async () => {
      const claimNumber = claimDetails?.claimDetails?.claim?.claimNumber
      if (!claimNumber) return

      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_PROVIDER_URL}/api/Claims/GetByClaimNumber/${claimNumber}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
            },
          }
        )

        if (!response.ok) {
          console.warn('Warning: Could not fetch claim details for status update')
          return
        }

        const claimData = await response.json()
        console.log('Fetched claim data for status:', claimData)

        // Sesuaikan path-nya dengan shape response API Anda
        const latestStatus =
          claimData?.data?.status || claimData?.status || claimData?.claim?.status
        if (latestStatus) {
          setCurrentStatus(latestStatus)
          setStatus(latestStatus) // sync dengan state `status` yang dipakai logic lainnya
        }
      } catch (error) {
        console.warn('Warning: Error fetching claim status:', error)
      }
    }

    fetchLatestStatus()
  }, [claimDetails?.claimDetails?.claim?.claimNumber, auth?.token, user.currentUser?.token])

  // Fetch Daily Monitoring and Discharge area documents on mount to compute request flags
  useEffect(() => {
    const fetchAreaFlags = async () => {
      const claimNumber = claimDetails?.claimDetails?.claim?.claimNumber
      if (!claimNumber) return

      const headers = {
        Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
      }

      try {
        // Fetch Daily Monitoring
        const dailyUrl = `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/ListFiles/${claimNumber}?area=Daily Monitoring`
        const dailyRes = await axios.get(dailyUrl, {headers})
        if (dailyRes.data.isSuccess) {
          const hasPending = dailyRes.data.data.some((doc: any) =>
            doc.document?.some(
              (file: any) => file.status === 'Request Document' || file.status === 'REQUEST'
            )
          )
          setHasDailyMonitoringRequest(hasPending)
        }

        // Fetch monitoring dates
        const monitoringUrl = `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/GetListDateClaimMonitoring?claimNumber=${claimNumber}`
        const monitoringRes = await axios.get(monitoringUrl, {headers})
        if (monitoringRes.data) {
          setMonitoringDates(monitoringRes.data)
        }

        // Fetch Discharge
        const dischargeUrl = `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/ListFiles/${claimNumber}?area=Discharge`
        const dischargeRes = await axios.get(dischargeUrl, {headers})
        if (dischargeRes.data.isSuccess) {
          const hasPending = dischargeRes.data.data.some((doc: any) =>
            doc.document?.some(
              (file: any) => file.status === 'Request Document' || file.status === 'REQUEST'
            )
          )
          setHasDischargeRequest(hasPending)
        }
      } catch (error) {
        console.error('Error fetching area flags:', error)
      }
    }

    fetchAreaFlags()
  }, [claimDetails?.claimDetails?.claim?.claimNumber, auth?.token, user.currentUser?.token])

  // Re-check monitoring dates when realtime update arrives
  const checkMonitoringDates = useCallback(async () => {
    const claimNumber = claimDetails?.claimDetails?.claim?.claimNumber
    if (!claimNumber) return

    const headers = {
      Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
    }

    try {
      const url = `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/GetListDateClaimMonitoring?claimNumber=${claimNumber}`
      const res = await axios.get(url, {headers})
      if (res.data) {
        setMonitoringDates(res.data)
      }
    } catch (error) {
      console.error('Error checking monitoring dates:', error)
    }
  }, [claimDetails?.claimDetails?.claim?.claimNumber, auth?.token, user.currentUser?.token])

  useEffect(() => {
    if (documentRealtime) {
      checkMonitoringDates()
    }
  }, [documentRealtime, checkMonitoringDates])

  const handleSave = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)
    try {
      const existingData = claimDetails?.claimDetails?.claim?.claimData
      const parsedExistingData = existingData ? JSON.parse(existingData) : {}

      const depositStr = diagnosisData.deposit || parsedExistingData.deposit || '0'
      const depositValue = parseFloat(depositStr.replace(/\./g, '').replace(/,/g, '.'))

      const payload = {
        claimNo: claimDetails?.claimDetails?.claim?.claimNumber,
        icdCode1: diagnosisData?.originalIcdCodes?.icd1 || parsedJson2?.IcdCode1 || '',
        icdCode2: diagnosisData?.originalIcdCodes?.icd2 || parsedJson2?.IcdCode2 || '',
        icdCode3: diagnosisData?.originalIcdCodes?.icd3 || parsedJson2?.IcdCode3 || '',
        icdCode4: diagnosisData.originalIcdCodes?.icd4 || parsedJson2.icdCode4 || '',
        doctor: diagnosisData.doctor || parsedExistingData.doctor || '',
        polyName: diagnosisData.polyName || parsedExistingData.polyName || '',
        remark: diagnosisData.remark || parsedExistingData.remark || '',
        deposit: depositValue,
        treatmentPlan: diagnosisData.rencanaTindakan || parsedExistingData.rencanaTindakan || '',
        los: diagnosisData.losEstimation
          ? parseInt(diagnosisData.losEstimation)
          : parseInt(parsedExistingData.los) || 0,
        updatedBy: user.currentUser?.email,
        BenefitDetail: {
          id: parsedJson?.Id,
          benefitName: parsedJson?.BenefitName,
          planName: parsedJson?.PlanName,
          benefitCode: parsedJson?.BenefitCode,
          condition: parsedJson?.Condition,
          annualLimit: parsedJson?.AnnualLimit,
          subBenefits:
            parsedJson?.SubBenefits?.map((subBenefit: any) => ({
              id: subBenefit.Id,
              category: 'INPATIENT',
              SubBenefitName: subBenefit.SubBenefitName,
              isCashless: subBenefit.IsCashless,
              isReimburstement: subBenefit.IsReimburstement,
              annualLimit: subBenefit.AnnualLimit,
              type: subBenefit.Type,
              claimValue: subBenefit.ClaimValue,
              details: subBenefit.Details,
              condition: subBenefit?.Condition || [],
              isAsCharge: subBenefit.IsAsCharge,
            })) || [],
        },
        indate:
          diagnosisData.indate !== undefined
            ? diagnosisData.indate
            : claimDetails?.claimDetails?.claim?.indate || '',
      }

      const headers = {
        Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
      }

      const response = await axios.post(
        `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/Provider/ProcessClaim/INPATIENT`,
        payload,
        {headers}
      )

      if (response.data.isSuccess) {
        // Clear unsaved diagnosis draft on successful save
        const claimNo = claimDetails?.claimDetails?.claim?.claimNumber
        if (claimNo) sessionStorage.removeItem(`diagnosisDraft:${claimNo}`)

        toast.success('Successfully saved as draft!', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: 'light',
          onOpen: () => {
          },
        })
        setIsEditing(false)
      } else {
        toast.error('Failed to save diagnosis data')
      }
    } catch (error: any) {
      console.error('Error saving diagnosis data:', error)
      toast.error(error.response?.data?.message || 'Error saving diagnosis data')
    }
  }

  const handleCancel = () => {
    // Your cancel logic here
    setIsEditing(false)
  }

  // Add handler for edit
  const handleEdit = () => {
    setIsEditing(true)
  }

  useEffect(() => {
    if (claimDetails?.claimDetails?.claim?.claimNumber) {
      const claimNumber = claimDetails.claimDetails?.claim?.claimNumber
      addClaimNumber(claimNumber)

      return () => {
        removeClaimNumber(claimNumber)
      }
    }
  }, [claimDetails])

  const updateClaimStatusVoid = async (claimNumber: string, remark: string) => {
    const apiUrl = `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/UpdateStatus`
    const payload = {
      claimNumber: claimNumber,
      status: 'Void',
      username: user.currentUser?.email,
      source: 'Provider',
      remarkRejectVoid: remark,
    }
    const headers = {
      Authorization: `Bearer ${user.currentUser?.token}`,
    }

    try {
      const response = await axios.post(apiUrl, payload, {headers})

      if (!response.data.isSuccess) {
        throw new Error('Failed to submit IGL Request')
      }

      // Invalidate and refetch claims queries to update the UI
      queryClient.invalidateQueries(['claims'])
      queryClient.invalidateQueries(['myTurnTotal'])

      toast.success('Update claim status successfully!', {
        position: 'bottom-right',
        autoClose: 3000,
      })

      // Refetch data after successful update
      setIsLoading(true)
      navigate('/claims')
    } catch (error) {
      console.error('Error updating claim status:', error)
      toast.error('Failed to update claim status', {
        position: 'bottom-right',
        autoClose: 3000,
      })
    }
  }

  const downloadDeclineLetter = async () => {
    const apiUrl = `${process.env.REACT_APP_API_CLAIM_URL}/api/Attachment/DownloadDL/${claimDetails?.claimDetails?.claim?.claimNumber}`
    const headers = {
      Authorization: `Bearer ${user.currentUser?.token}`,
    }
    try {
      const response = await axios.get(apiUrl, {headers})
      console.log('response: ', response)

      // Handle new response format with URL object
      if (response.data && response.data.url) {
        const downloadUrl = response.data.url
        const fileName = response.data.name
          ? response.data.name.split('/').pop()
          : `${claimDetails?.claimDetails?.claim?.claimNumber}${response.data.extention || '.pdf'}`

        // Create a temporary anchor element to download from the signed URL
        const a = document.createElement('a')
        a.href = downloadUrl
        a.download = fileName
        a.target = '_blank'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      } else {
        // Fallback to old method if response format is different
        const blob = new Blob([response.data], {type: 'application/pdf'})
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = `${claimDetails?.claimDetails?.claim?.claimNumber}.pdf`
        a.click()
        window.URL.revokeObjectURL(url)
      }
    } catch (error) {
      console.error('Error downloading decline letter:', error)
      toast.error('Failed to download decline letter', {
        position: 'top-right',
        autoClose: 3000,
      })
    }
  }

  const handleCancelClick = () => {
    setShowCancelModal(true)
  }

  const handleModalClose = () => {
    setShowCancelModal(false)
    setRemark('')
    setIsConfirmCancel(false)
  }

  const handleConfirmCancel = () => {
    if (!remark.trim()) {
      setShowRemarkError(true)
      return
    }
    updateClaimStatusVoid(claimDetails?.claimDetails?.claim?.claimNumber, remark)
    handleModalClose()
    setRemark('')
    setShowRemarkError(false)
  }

  // Add handlers for Superseding Request modal
  const handleSupersedingClick = (type: string) => {
    setCurrentSupersedingType(type)
    setShowSupersedingModal(true)
  }

  const handleSupersedingModalClose = () => {
    setShowSupersedingModal(false)
    setSupersedingRemark('')
    setShowSupersedingRemarkError(false)
    setCategorySuperseding('')
    setShowSupersedingCategoryError(false)
    setSupersedingFiles([])
    setCurrentSupersedingType('')
    statusSubmittedRef.current = false
  }

  const handleConfirmSuperseding = async () => {
    if (!categorySuperseding) {
      setShowSupersedingCategoryError(true)
      return
    }
    if (!supersedingRemark.trim()) {
      setShowSupersedingRemarkError(true)
      return
    }

    try {
      // STEP 1: Update claim status — only runs once; safe to retry after upload failure
      if (!statusSubmittedRef.current) {
        await updateClaimStatusSupersedingRequest(
          currentSupersedingType,
          supersedingRemark,
          categorySuperseding
        )
        statusSubmittedRef.current = true
      }

      // STEP 2: Upload documents after status update succeeds
      if (supersedingFiles.length > 0) {
        const uploadResult = await uploadSupersedingDocsMutation.mutateAsync({
          claimNumber: claimDetails.claimDetails.claim.claimNumber,
          username: user.currentUser?.email || 'System',
          files: supersedingFiles,
        })
        if (uploadResult?.isSuccess === false) {
          throw new Error(uploadResult?.message || 'Document upload failed')
        }
      }

      statusSubmittedRef.current = false
      handleSupersedingModalClose()
      navigate('/claims')
    } catch (error: any) {
      console.error('Error submitting superseding request:', error)
      toast.error(
        statusSubmittedRef.current
          ? (error?.message || 'Request submitted, but document upload failed — please retry the upload.')
          : (error?.message || 'Failed to submit superseding request'),
        {position: 'bottom-right', autoClose: 3000}
      )
    }
  }

  // If claimDetails is not valid, don't render the component
  if (!claimDetails || !claimDetails.claimDetails || !claimDetails.claimDetails.claim) {
    return null
  }

  const renderSupersedingButtons = (type: string) => {
    // IDH-1155: only the FGL Superseding Request button is hidden during impersonation.
    // IGL and Daily Monitoring superseding buttons remain visible. The View/tracking
    // button is rendered universally (see the frame-igl container), so here we only
    // render the Submit button.
    const hideSubmitForImpersonation = type === 'FGL' && !!auth?.isImpersonation

    if (!hasActiveSuperseding && !hideSubmitForImpersonation) {
      return (
        <button
          className='frame-button20'
          style={{
            backgroundColor: '#2A9D8F',
            color: 'white',
            cursor: 'pointer',
            border: 'none',
            borderRadius: '0.475rem',
            padding: '0.75rem',
          }}
          onClick={() => handleSupersedingClick(type)}
        >
          <span className='frame-text42 Body500Md'>
            {type === 'Daily Monitoring' ? 'Superseding Request' : `${type} Superseding Request`}
          </span>
        </button>
      )
    }

    return null
  }

  return (
    <>
      <div className='card card-custom gutter-b' style={{marginTop: '-50px'}}>
        <div className='frame-header'>
          <div className='frame-headertop'>
            <div className='frame-menu2'>
              <span className='frame-text36'>{claimDetails.claimDetails?.claim?.claimNumber}</span>
              <div className='frame-row25'>
                <div className='frame-label20'>
                  <span className='frame-text37'>{f({id: 'CLAIM.INPATIENT.INPATIENT'})}</span>
                </div>
              </div>
            </div>
            <div className='frame-row26'>
              <div
                className={
                  currentStatus.toLowerCase() === 'pending data'
                    ? 'frame-statuslabel'
                    : currentStatus.toLowerCase() === 'daily monitoring'
                    ? 'frame-statuslabel-1'
                    : 'frame-statuslabel-2'
                }
              >
                <span
                  className={
                    currentStatus.toLowerCase() === 'pending data'
                      ? 'frame-text38'
                      : currentStatus.toLowerCase() === 'daily monitoring'
                      ? 'frame-text42'
                      : 'frame-text45'
                  }
                >
                  {currentStatus}
                </span>
              </div>
            </div>
            <div className='frame-row26' style={{display: 'flex', alignItems: 'center', gap: '8px',justifyContent: 'end'}}>
              {/* Add chat icon button here */}
              <button
                className='btn btn-icon btn-active-light-primary'
                onClick={() => setIsChatModalOpen(true)}
                style={{
                  border: 'none',
                  background: 'none',
                  cursor: 'pointer',
                  padding: '5px',
                }}
              >
                <FaComment size={20} color='#059BB6' />
              </button>
              <button
                className='btn btn-sm'
                onClick={() => setShowTrackingModal(true)}
                style={{
                  backgroundColor: '#F4A261',
                  color: 'white',
                  cursor: 'pointer',
                  border: 'none',
                  borderRadius: '0.475rem',
                  padding: '0.75rem',
                  whiteSpace: 'nowrap',
                }}
              >
                <span className='Body500Md'>
                  {f({id: 'CLAIM.INPATIENT.SUPERSEDING_TRACKING_TITLE'}) || 'View Superseding Status'}
                </span>
              </button>
            </div>
          </div>
          <div className='frame-headerhelper'>
            <div className='frame-row29'>
              <span className='frame-text39'>{f({id: 'CLAIM.INPATIENT.PATIENT_NAME'})}</span>
              <span className='frame-text40'>{claimDetails.claimDetails?.claim?.memberName}</span>
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                position: 'relative',
                gap: '6px',
              }}
            >
              <button
                className='frame-button19'
                onClick={() => handleViewNavigation('prev')}
                style={{
                  visibility: showPrevButton && currentView !== 'inpatient' ? 'visible' : 'hidden',
                  cursor: 'pointer',
                  border: 'none',
                  background: 'none',
                  padding: '4px',
                  color: '#7E8299',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <svg
                  width='20'
                  height='20'
                  viewBox='0 0 24 24'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M15 19L8 12L15 5'
                    stroke='currentColor'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
              </button>
              <div
                className='frame-indicator1'
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <span className='frame-text41'>
                  {status === 'Request FGL' ||
                  status === 'FGL RELEASED' ||
                  status === 'FGL Released' ||
                  status === 'Final Document Complete' ||
                  status === 'FGL Review' ||
                  status === 'Pending on FGL'
                    ? currentView === 'discharged'
                      ? 'DISCHARGED'
                      : currentView === 'calendar'
                      ? 'Daily Monitoring'
                      : 'Admission'
                    : currentView === 'inpatient'
                    ? 'Admission'
                    : 'Daily Monitoring'}
                </span>
              </div>
              <button
                className='frame-button19'
                onClick={() => handleViewNavigation('next')}
                style={{
                  visibility: showNextButton ? 'visible' : 'hidden',
                  cursor: 'pointer',
                  border: 'none',
                  background: 'none',
                  padding: '4px',
                  color: '#7E8299',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <svg
                  width='20'
                  height='20'
                  viewBox='0 0 24 24'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M9 5L16 12L9 19'
                    stroke='currentColor'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
              </button>
            </div>
            <div className='frame-row30'>
              <div className='frame-row31'>
                <div
                  className='frame-igl'
                  style={{display: 'flex', gap: '10px', alignItems: 'center'}}
                >
                  {status === 'Reject' && (
                    <button
                      className='btn btn-danger cursor-pointer'
                      style={{fontSize: '12px', padding: '0.75rem 1.5rem'}}
                      onClick={downloadDeclineLetter}
                    >
                      <LuDownload style={{fontSize: '16px', marginRight: '4px'}} />
                      RL
                    </button>
                  )}
                  {status !== 'Void' && status === 'Pre-Registered' && (
                    <button
                      className='btn btn-danger cursor-pointer'
                      style={{fontSize: '12px', padding: '0.75rem 1.5rem'}}
                      onClick={handleCancelClick}
                    >
                      Void
                    </button>
                  )}
                  {(status === 'Pre-Registered' ||
                    status === 'Pending on IGL' ||
                    isEditingDiagnosis) && (
                    <button
                      type='submit'
                      className='frame-button11'
                      style={{
                        backgroundColor: '#127289',
                        color: 'white',
                        border: 'none',
                        borderRadius: '0.475rem',
                        padding: '0.75rem 1.5rem',
                        cursor: 'pointer',
                      }}
                      onClick={handleSave}
                    >
                      <span className='frame-text27 Body500Md'>Save As Draft</span>
                    </button>
                  )}

                  {/* {status === "Daily Monitoring" && (
                    <button
                      type="button"
                      className="frame-button11"
                      style={{
                        backgroundColor: '#127289',
                        color: 'white',
                        border: 'none',
                        borderRadius: '0.475rem',
                        padding: '0.75rem 1.5rem',
                        cursor: 'pointer'
                      }}
                      onClick={() => {
                        setCurrentView('calendar');
                        setView('calendar');
                        setActiveKey('calendar');
                        setTimeout(() => {
                          setCurrentView('calendar');
                        }, 0);
                      }}
                    >
                      <span className="frame-text27 Body500Md">Back</span>
                    </button>
                  )} */}

                  {/* {status === "Daily Monitoring" && (
                    <button
                      type="button"
                      className="frame-button11"
                      style={{
                        backgroundColor: '#059BB6',
                        color: 'white',
                        border: 'none',
                        borderRadius: '0.475rem',
                        padding: '0.75rem 1.5rem',
                        cursor: 'pointer'
                      }}
                      onClick={() => {
                        setCurrentView('calendar');
                        setView('calendar');
                        setActiveKey('calendar');
                        setTimeout(() => {
                          setCurrentView('calendar');
                        }, 0);
                      }}
                    >
                      <span className="frame-text27 Body500Md">Back</span>
                    </button>
                  )} */}

                  {status === 'Waiting Enquiry Response' && (
                    <button
                      className='frame-button20'
                      style={{
                        backgroundColor: '#2A9D8F',
                        color: 'white',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '5px',
                        border: 'none',
                        borderRadius: '0.475rem',
                        padding: '0.75rem 1.5rem',
                      }}
                      onClick={() => updateClaimStatusMedicalInquiry()}
                    >
                      <span className='frame-text42 Body500Md'>Submit Response</span>
                    </button>
                  )}

                  {status === 'IGL RELEASED' || status === 'IGL Released' ? (
                    <div style={{display: 'flex', gap: '10px'}}>
                      <button
                        className='frame-button20'
                        style={{
                          backgroundColor: '#127289',
                          color: 'white',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '5px',
                          border: 'none',
                          borderRadius: '0.475rem',
                          padding: '0.75rem 1.5rem',
                        }}
                        onClick={handleDownloadIGL}
                      >
                        <HiOutlineDocumentDownload size={16} />
                        <span className='frame-text42 Body500Md'>IGL</span>
                      </button>
                      <button
                        className='frame-button20'
                        style={{
                          backgroundColor: monitoringDates.length > 0 ? '#127289' : '#E4E6EF',
                          color: 'white',
                          cursor: monitoringDates.length > 0 ? 'pointer' : 'not-allowed',
                          border: 'none',
                          borderRadius: '0.475rem',
                          padding: '0.75rem 1.5rem',
                        }}
                        onClick={handleRequestFGL}
                        disabled={monitoringDates.length === 0}
                      >
                        <span className='frame-text42 Body500Md'>Request FGL</span>
                      </button>
                      {renderSupersedingButtons('IGL')}
                    </div>
                  ) : status === 'FGL RELEASED' || status === 'FGL Released' ? (
                    <div style={{display: 'flex', gap: '10px'}}>
                      <button
                        className='frame-button20'
                        style={{
                          backgroundColor: '#127289',
                          color: 'white',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '5px',
                          border: 'none',
                          borderRadius: '0.475rem',
                          padding: '0.75rem 1.5rem',
                        }}
                        onClick={handleDownloadIGL}
                      >
                        <HiOutlineDocumentDownload size={16} />
                        <span className='frame-text42 Body500Md'>IGL</span>
                      </button>
                      <button
                        className='frame-button20'
                        style={{
                          backgroundColor: '#127289',
                          color: 'white',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '5px',
                          border: 'none',
                          borderRadius: '0.475rem',
                          padding: '0.75rem 1.5rem',
                        }}
                        onClick={handleDownloadFGL}
                      >
                        <HiOutlineDocumentDownload size={16} />
                        <span className='frame-text42 Body500Md'>FGL</span>
                      </button>
                      {renderSupersedingButtons('FGL')}
                    </div>
                  ) : status === 'Registered' ||
                    status === 'Pre-Registered' ||
                    status === 'Pending on IGL' ? (
                    <div className='tooltip-container' style={{position: 'relative'}}>
                      <button
                        className='frame-button20'
                        style={{
                          backgroundColor: !shouldEnableButton || loading ? '#E4E6EF' : '#127289',
                          color: 'white',
                          cursor: !shouldEnableButton || loading ? 'not-allowed' : 'pointer',
                          border: 'none',
                          borderRadius: '0.475rem',
                          padding: '0.75rem 1.5rem',
                          transition: 'background-color 0.3s ease',
                        }}
                        onClick={handleRequestIGL}
                        disabled={!shouldEnableButton || loading}
                        onMouseEnter={(e) => {
                          const tooltip = e.currentTarget.parentElement?.querySelector('.tooltip')
                          if (tooltip && !loading) {
                            tooltip.classList.add('visible')
                          }
                        }}
                        onMouseLeave={(e) => {
                          const tooltip = e.currentTarget.parentElement?.querySelector('.tooltip')
                          if (tooltip) {
                            tooltip.classList.remove('visible')
                          }
                        }}
                      >
                        {loading ? (
                          <>
                            <span className='spinner-border spinner-border-sm me-2' role='status' aria-hidden='true' />
                            <span className='frame-text42 Body500Md'>Request IGL...</span>
                          </>
                        ) : (
                          <span className='frame-text42 Body500Md'>Request IGL</span>
                        )}
                      </button>
                      {!shouldEnableButton && !loading && (
                        <div
                          className='tooltip'
                          style={{
                            position: 'absolute',
                            top: '45px',
                            right: '0px',
                            backgroundColor: 'white',
                            padding: '12px 16px',
                            borderRadius: '6px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                            width: '320px',
                            maxWidth: 'calc(100vw - 40px)',
                            zIndex: 1000,
                            border: '1px solid #e9ecef',
                            opacity: 0,
                            visibility: 'hidden',
                            transition: 'opacity 0.2s, visibility 0.2s',
                          }}
                        >
                          <div
                            style={{
                              fontSize: '13px',
                              color: '#495057',
                              marginBottom: '12px',
                              fontWeight: 500,
                              borderBottom: '1px solid #e9ecef',
                              paddingBottom: '8px',
                            }}
                          >
                            {f({id: 'CLAIM.INPATIENT.COMPLETE_REQUIREMENTS'})}
                          </div>
                          <ul
                            style={{
                              margin: 0,
                              padding: '0 0 0 20px',
                              fontSize: '12px',
                              color: '#6c757d',
                              display: 'flex',
                              flexDirection: 'column',
                              gap: '8px',
                            }}
                          >
                            {getRequestIGLWarnings().map((warning, index) => (
                              <li
                                key={index}
                                style={{
                                  lineHeight: '1.4',
                                  position: 'relative',
                                }}
                              >
                                {warning.includes(':') ? (
                                  <>
                                    {warning.split(':')[0]}:
                                    <span style={{color: '#dc3545', marginLeft: '4px'}}>
                                      {warning.split(':')[1]}
                                    </span>
                                  </>
                                ) : (
                                  warning
                                )}
                                {warning.includes('Missing diagnosis fields') && (
                                  <ul
                                    style={{
                                      margin: '4px 0 0 0',
                                      padding: '0 0 0 20px',
                                      listStyle: 'none',
                                    }}
                                  >
                                    {warning
                                      .split(':')[1]
                                      .split(',')
                                      .map((field, i) => (
                                        <li
                                          key={i}
                                          style={{
                                            color: '#dc3545',
                                            fontSize: '11px',
                                            marginTop: '2px',
                                          }}
                                        >
                                          {field.trim()}
                                        </li>
                                      ))}
                                  </ul>
                                )}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  ) : status === 'Daily Monitoring' ? (
                    <div style={{display: 'flex', gap: '10px'}}>
                      <button
                        className='frame-button20'
                        style={{
                          backgroundColor: '#127289',
                          color: 'white',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '5px',
                          border: 'none',
                          borderRadius: '0.475rem',
                          padding: '0.75rem 1.5rem',
                        }}
                        onClick={handleDownloadIGL}
                      >
                        <HiOutlineDocumentDownload size={16} />
                        <span className='frame-text42 Body500Md'>IGL</span>
                      </button>
                      <button
                        className='frame-button20'
                        style={{
                          backgroundColor: monitoringDates.length > 0 ? '#127289' : '#E4E6EF',
                          color: 'white',
                          cursor: monitoringDates.length > 0 ? 'pointer' : 'not-allowed',
                          border: 'none',
                          borderRadius: '0.475rem',
                          padding: '0.75rem 1.5rem',
                        }}
                        onClick={handleRequestFGL}
                        disabled={monitoringDates.length === 0}
                      >
                        <span className='frame-text42 Body500Md'>Request FGL</span>
                      </button>
                      {renderSupersedingButtons('Daily Monitoring')}
                    </div>
                  ) : status === 'Pending on FGL' ? (
                    <div>
                      <button
                        className='frame-button20'
                        style={{
                          backgroundColor: canRequestFGL ? '#127289' : '#E4E6EF',
                          color: 'white',
                          cursor: canRequestFGL ? 'pointer' : 'not-allowed',
                          border: 'none',
                          borderRadius: '0.475rem',
                          padding: '0.75rem 1.5rem',
                        }}
                        onClick={updateClaimStatusFGLReviewWhenPending}
                        disabled={!canRequestFGL}
                      >
                        <span className='frame-text42 Body500Md'>Request FGL</span>
                      </button>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
        <InpatientPage
          claimDetails={claimDetails}
          onDocumentsStatusChange={handleDocumentsStatusChange}
          isEditingDiagnosis={isEditingDiagnosis}
          onEditClick={handleEditClick}
          onDocumentClick={handleDocumentClick}
          onValidateDiagnosis={validateDiagnosisFields}
          isFromDailyMonitoring={isFromDailyMonitoring}
          onDiagnosisDataChange={handleDiagnosisDataChange}
          currentView={currentView}
          setIsReupload={setReuploadWithLogging}
          onDocumentRealtimeUpdate={handleDocumentRealtimeUpdate}
          isDiagnosisValid={isDiagnosisValid}
          documentsUploaded={documentsUploaded}
          documentsChecked={documentsChecked}
          hasDailyMonitoringRequest={hasDailyMonitoringRequest}
          hasDischargeRequest={hasDischargeRequest}
        />
      </div>

      {showFGLModal && (
        <CreateAppModal
          show={showFGLModal}
          handleClose={() => setShowFGLModal(false)}
          claimDetails={claimDetails}
          formattedDate={formattedDate}
          onSuccessSubmit={() => {
            sessionStorage.removeItem('recentlyUploadedLabels')
            setShowFGLModal(false)
            navigate('/claims')
          }}
        />
      )}
      <DocumentModal
        isOpen={isChatOpen}
        onClose={() => setIsChatOpen(false)}
        claimNumber={claimDetails.claimDetails?.claim?.claimNumber}
        token={user.currentUser?.token}
      />
      {isChatModalOpen && claimDetails && (
        <ChatModal
          isOpen={isChatModalOpen}
          onClose={() => setIsChatModalOpen(false)}
          message=''
          claimDetails={claimDetails.claimDetails}
        />
      )}

      {/* Metronic Cancel Confirmation Modal */}
      <Modal
        id='kt_modal_cancel_claim'
        show={showCancelModal}
        onHide={handleModalClose}
        aria-hidden='true'
        dialogClassName='modal-dialog modal-dialog-centered'
        contentClassName='modal-content rounded'
      >
        <div className='modal-header pb-0 border-0 justify-content-end'>
          <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleModalClose}>
            <IoIosClose size={24} />
          </div>
        </div>

        <div className='modal-body scroll-y px-10 px-lg-15 pt-0 pb-15'>
          <div className='mb-13 text-center'>
            <h1 className='mb-3'>{f({id: 'CLAIM.INPATIENT.CONFIRMATION_OF_CLAIM_VOID'})}</h1>
          </div>

          <div className='d-flex flex-column mb-8'>
            <div className='text-center mb-5'>
              <p className='text-gray-800 fs-6 fw-semibold'>
                {f(
                  {id: 'CLAIM.INPATIENT.CONFIRMATION_OF_CLAIM_VOID_DESCRIPTION'},
                  {
                    claimNumber: claimDetails?.claimDetails?.claim?.claimNumber,
                    memberName: claimDetails?.claimDetails?.claim?.memberName,
                  }
                )}
              </p>
              {/* <p>
                Are you sure you want to void claim {claimDetails?.claimDetails?.claim?.claimNumber}{' '}
                on behalf of {claimDetails?.claimDetails?.claim?.memberName}?
              </p> */}
            </div>

            {isConfirmCancel && (
              <div className='form-group'>
                <label className='required fw-semibold fs-6 mb-2'>Remark</label>
                <textarea
                  className={`form-control ${showRemarkError ? 'is-invalid' : ''}`}
                  rows={3}
                  value={remark}
                  onChange={(e) => {
                    setRemark(e.target.value)
                    setShowRemarkError(false)
                  }}
                />
                {showRemarkError && (
                  <div className='invalid-feedback'>
                    {f({id: 'CLAIM.INPATIENT.MODAL_VOID_REMARK_REQUIRED'})}
                  </div>
                )}
              </div>
            )}
          </div>

          <div className='d-flex flex-center flex-row-fluid pt-12'>
            <button type='reset' className='btn btn-light me-3' onClick={handleModalClose}>
              {f({id: 'CLAIM.INPATIENT.MODAL_CANCEL'})}
            </button>

            {!isConfirmCancel && (
              <button
                type='button'
                className='btn btn-primary'
                onClick={() => setIsConfirmCancel(true)}
              >
                {f({id: 'CLAIM.INPATIENT.MODAL_CONFIRM'})}
              </button>
            )}

            {isConfirmCancel && (
              <button
                type='button'
                className='btn btn-primary'
                onClick={handleConfirmCancel}
                disabled={!remark.trim()}
              >
                {f({id: 'CLAIM.INPATIENT.MODAL_SUBMIT'})}
              </button>
            )}
          </div>
        </div>
      </Modal>

      {/* IGL/FGL Superseding Request Modal */}
      <Modal
        id='kt_modal_superseding_request'
        show={showSupersedingModal}
        onHide={handleSupersedingModalClose}
        aria-hidden='true'
        dialogClassName='modal-dialog modal-dialog-centered'
        contentClassName='modal-content rounded'
      >
        <div className='modal-header pb-0 border-0 justify-content-end'>
          <div
            className='btn btn-sm btn-icon btn-active-color-primary'
            onClick={handleSupersedingModalClose}
          >
            <IoIosClose size={24} />
          </div>
        </div>

        <div className='modal-body scroll-y px-10 px-lg-15 pt-0 pb-15'>
          <div className='mb-13 text-center'>
            <h1 className='mb-3'>{currentSupersedingType} Superseding Request</h1>
          </div>

          <div className='d-flex flex-column mb-8'>
            <div className='text-center mb-5'>
              <p className='text-gray-800 fs-6 fw-semibold'>
                {f(
                  {id: 'CLAIM.INPATIENT.SUPERSEDING_REQUEST_DESCRIPTION'},
                  {
                    currentSupersedingType: currentSupersedingType,
                    claimNumber: claimDetails?.claimDetails?.claim?.claimNumber,
                    memberName: claimDetails?.claimDetails?.claim?.memberName,
                  }
                )}
                {/* Please provide a reason for the {currentSupersedingType} superseding request for
                claim {claimDetails?.claimDetails?.claim?.claimNumber} on behalf of{' '}
                {claimDetails?.claimDetails?.claim?.memberName}: */}
              </p>
            </div>

            <div className='form-group mb-5'>
              <label className='required fw-semibold fs-6 mb-2'>
                {f({id: 'CLAIM.INPATIENT.SUPERSEDING_CATEGORY'}) || 'Category'}
              </label>
              <select
                className={`form-select ${showSupersedingCategoryError ? 'is-invalid' : ''}`}
                value={categorySuperseding}
                onChange={(e) => {
                  setCategorySuperseding(e.target.value)
                  setShowSupersedingCategoryError(false)
                }}
              >
                <option value=''>{f({id: 'CLAIM.INPATIENT.SUPERSEDING_CATEGORY_PLACEHOLDER'}) || 'Select Category'}</option>
                {SUPERSEDING_CATEGORIES.map((category) => (
                  <option key={category.value} value={category.value}>
                    {f({id: category.i18nKey}) || category.value}
                  </option>
                ))}
              </select>
              {showSupersedingCategoryError && (
                <div className='invalid-feedback'>
                  {f({id: 'CLAIM.INPATIENT.SUPERSEDING_CATEGORY_REQUIRED'}) || 'Category is required'}
                </div>
              )}
            </div>

            <div className='form-group mb-5'>
              <label className='required fw-semibold fs-6 mb-2'>
                {f({id: 'CLAIM.INPATIENT.SUPERSEDING_REQUEST_REASON'})}
              </label>
              <textarea
                className={`form-control ${showSupersedingRemarkError ? 'is-invalid' : ''}`}
                rows={4}
                value={supersedingRemark}
                onChange={(e) => {
                  setSupersedingRemark(e.target.value)
                  setShowSupersedingRemarkError(false)
                }}
                placeholder={f({id: 'CLAIM.INPATIENT.SUPERSEDING_REQUEST_REASON_PLACEHOLDER'})}
                style={{resize: 'vertical', minHeight: '100px'}}
              />
              {showSupersedingRemarkError && (
                <div className='invalid-feedback'>
                  {f({id: 'CLAIM.INPATIENT.SUPERSEDING_REQUEST_REASON_REQUIRED'})}
                </div>
              )}
            </div>

            <div className='form-group mb-5'>
              <label className='fw-semibold fs-6 mb-2'>
                {f({id: 'CLAIM.INPATIENT.SUPERSEDING_FILE_UPLOAD'}) || 'File Attachments (Optional)'}
              </label>
              <div className='d-flex flex-column gap-3'>
                <input
                  type='file'
                  className='form-control'
                  multiple
                  accept='.pdf,.jpg,.jpeg,.png'
                  onChange={(e) => {
                    const selectedFiles = Array.from(e.target.files || [])
                    // Use ref to always get current files count (avoids stale closure)
                    const currentFiles = supersedingFilesRef.current
                    const combined = [...currentFiles, ...selectedFiles]

                    if (combined.length > 5) {
                      toast.error(`Maximum 5 files allowed (currently ${currentFiles.length} selected)`)
                      e.target.value = ''
                      return
                    }
                    const oversizedFiles = selectedFiles.filter(f => f.size > 10 * 1024 * 1024)
                    if (oversizedFiles.length > 0) {
                      toast.error(`File too large: ${oversizedFiles.map(f => f.name).join(', ')} (max 10MB each)`)
                      e.target.value = ''
                      return
                    }
                    setSupersedingFiles(combined)
                    e.target.value = ''
                  }}
                />
                
                {/* List of selected files */}
                {supersedingFiles.length > 0 && (
                  <div className='d-flex flex-column gap-2'>
                    {supersedingFiles.map((file, index) => (
                      <div key={index} className='d-flex align-items-center justify-content-between p-2 border rounded bg-light'>
                        <span className='fs-7 text-truncate' style={{maxWidth: '80%'}}>{file.name}</span>
                        <button 
                          className='btn btn-icon btn-sm btn-light-danger' 
                          onClick={() => setSupersedingFiles(prev => prev.filter((_, i) => i !== index))}
                        >
                          <IoIosClose size={20} />
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <div className='text-muted fs-7 mt-2'>
                {f({id: 'CLAIM.INPATIENT.SUPERSEDING_FILE_HINT'}) || 'PDF + images, <= 10 MB per file, <= 5 files total'}
              </div>
            </div>
          </div>

          <div className='d-flex flex-center flex-row-fluid pt-12'>
            <button
              type='reset'
              className='btn btn-light me-3'
              onClick={handleSupersedingModalClose}
            >
              {f({id: 'CLAIM.INPATIENT.MODAL_CANCEL'})}
            </button>
            <button
              type='button'
              className='btn btn-primary d-flex align-items-center gap-2'
              onClick={handleConfirmSuperseding}
              disabled={!supersedingRemark.trim() || !categorySuperseding || uploadSupersedingDocsMutation.isLoading}
            >
              {uploadSupersedingDocsMutation.isLoading && <span className='spinner-border spinner-border-sm' />}
              {f({id: 'CLAIM.INPATIENT.MODAL_CONFIRM'})}
            </button>
          </div>
        </div>
      </Modal>

      <style>
        {`
          .tooltip-container:hover .tooltip {
            opacity: 1 !important;
            visibility: visible !important;
          }
          
          .tooltip.visible {
            opacity: 1 !important;
            visibility: visible !important;
          }
          
          .tooltip::before {
            content: '';
            position: absolute;
            bottom: -16px;
            right: 20px;
            transform: translateY(-50%) rotate(180deg);
            border-width: 8px 8px 0 8px;
            border-style: solid;
            border-color: #e9ecef transparent transparent transparent;
          }

          .tooltip li::before {
            
            color: #dc3545;
            font-weight: bold;
            display: inline-block;
            width: 1em;
            margin-left: -1em;
          }
        `}
      </style>

      {showTrackingModal && (
        <SupersedingTrackingModal
          show={showTrackingModal}
          onHide={() => setShowTrackingModal(false)}
          claimNumber={claimDetails?.claimDetails?.claim?.claimNumber}
          username={user.currentUser?.email || 'System'}
          isImpersonation={!!auth?.isImpersonation}
        />
      )}
    </>
  )
}

export default InpatientPageWrapper
